export default __webpack_public_path__ + "static/media/Group -6@2x.d88f843a.png";